//GeneratorFlag:[NoChange]
import PersonReal from './person-real';
import PersonGender from './person-gender';
import PersonGrade from './person-grade';
import PersonMarital from './person-marital';
import PersonMilitary from './person-military';
import PersonNationality from './person-nationality';

export default {PersonReal, PersonGender, PersonGrade, PersonMarital, PersonMilitary, PersonNationality}
export{PersonReal, PersonGender, PersonGrade, PersonMarital, PersonMilitary, PersonNationality}